webpackJsonp([77],{

/***/ 1329:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1330);


/***/ }),

/***/ 1330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _es = __webpack_require__(772);

var _es2 = _interopRequireDefault(_es);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('es', _es2.default);

/***/ })

},[1329]);


// WEBPACK FOOTER //
// app/datetime.es-3d141d68b2f0a364669c.js